<template>
  <div class="ui grid">
    <div class="ui row">
      <div
        v-for="(c, index) in choices"
        :key="index"
        class="ui eight wide choice column"
        :class="{selected: isSelected(c.type)}"
        @click="select(c.type)"
      >
        <img
          :src="c.icon"
          class="ui raised fitted segment"
          :alt="c.title"
        />
        {{ c.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChoiceGrid',
  props: ['choices'],
  data() {
    return {
      selected: '',
    };
  },
  methods: {
    select(item) {
      this.selected = item;
    },
    isSelected(item) {
      return item === this.selected;
    },
  },
  mounted() {
    this.selected = this.choices[0].type;
  },
};
</script>

<style lang="less" scoped>
.choice {
  cursor: pointer;
  text-align: center;
  &.selected {
    font-weight: bold;
    img {
      border: 2px solid #67b44b;
    }
  }
  img {
    border-radius: 8px;
  }
}
</style>
